import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { graphql } from "react-apollo";

import { useAuthState, useAuthDispatch } from "../Context";
import { notify } from "../generic";
import { login } from "../../api/queries/utilisateur.mutations";
import ValidatedLoginForm from "../components/ValidatedLoginForm";

function LoginPage(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleLogin = async e => {
    try {
      let response = await _mutateLoginUser(e); //loginUser action makes the request and handles all the neccessary state changes

      if (!response) return;

      navigate(0);
    } catch (error) {
      console.log({ error });
    }
  };

  const _mutateLoginUser = async ({ email, password }) => {
    try {
      return props
        .login({
          variables: {
            email,
            password
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.login;

          if (type === "success") {
            dispatch({ type: "REQUEST_LOGIN" });
            const { user } = JSON.parse(details);

            if (user.token) {
              dispatch({ type: "LOGIN_SUCCESS", payload: user });
              localStorage.setItem("currentUser", JSON.stringify(user));
              return user;
            }
          } else {
            notify("error", message);
            setShowForgotPassword(true);
            dispatch({ type: "LOGIN_ERROR", error: message });
          }
        });

      return;
    } catch (error) {
      alert("eee");
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  return (
    <div>
      <div className="homeFooter">
        <a href="https://www.penge.fr/mentions-legales">
          politique de confidentialité
        </a>
      </div>
      <div className="sidenav">
        <div className="login-main-text">
          <img id="logo" src="/img/penge_logo_white.png" width="177" />
        </div>
      </div>
      <div className="main push">
        <div className="login-form">
          <ValidatedLoginForm
            handleSubmit={handleLogin}
            showForgotPassword={showForgotPassword}
          />
        </div>
      </div>
    </div>
  );
}

export default graphql(login, {
  name: "login"
})(LoginPage);
